import {Component, ViewChild, OnInit, ViewChildren, QueryList, AfterViewInit} from '@angular/core';
import { MatTable } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { Evaluacion } from 'app/main/models/evaluacion.model';
import { Router } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EvaluacionesListComponent} from './cards/evaluaciones-list.component'


const ELEMENT_DATA: Evaluacion[] = [];

@Component({
    selector   : 'mis-evaluaciones',
    templateUrl: './evaluacion.component.html',
    styleUrls  : ['./evaluacion.component.scss']
})
export class MisEvaluacionesComponent implements AfterViewInit
{
    imprimible: boolean = false;
    deleteable: boolean = true;
    editable: boolean = true;
    
    displayedColumns: string[] = ['nombre','version','estructuraJerarquica','creador','dueno','fechaInicio','fechaFin','action'];
    dataSourcePreiniciado: Evaluacion[] = [];
    dataSourceIniciado: Evaluacion[] = [];
    dataSourceCompletado: Evaluacion[] = [];
    dataSourceAprobado: Evaluacion[] = [];
    dataSourceCerrado: Evaluacion[] = [];
    role = [];
    titulo = "Mis evaluaciones";
    filterForm: FormGroup;
    estados: string[] = ["PRE_INICIADO","INICIADO","COMPLETADO","APROBADO","CERRADO"];

    //@ViewChild('drawer') sidenav: MatDrawer;

    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    //@ViewChild(EvaluacionesListComponent, {static : true}) child : EvaluacionesListComponent;
    @ViewChildren(EvaluacionesListComponent) children: QueryList<EvaluacionesListComponent>;


    constructor(public dialog: MatDialog,
                public router: Router,
                private _snackBar: MatSnackBar,
                private _formBuilder: FormBuilder,
                public translate: TranslateService) {}

    ngAfterViewInit(): void {
        this.loadData();
    }

    loadData():void{
        //this.child.getElements(0);
        this.children.forEach(child => {
            child.getElements(0);
        });
    }
   
    navegateTo(url, id): void  {
        this.router.navigate([url, id]).then( (e) => {
          if (e) {
            console.log("Navigation is successful!");
          } else {
            console.log("Navigation has failed!");
          }
        });
    }

    openSnackBar(message: string, action: string) {
      this._snackBar.open(message, action, {
        duration: 3000,
      });
    }

    tieneUsuario(usuario,listaUsuarios):boolean{
      var tiene = false;
      listaUsuarios.forEach(element => {
         if(usuario===element.correoElectronico)
            tiene = true;
      });

      return tiene;
    }

    print(event):void{}


}
